import { resolveTelepointerPresentation } from '../../ui/components/TelepointerAvatar/telepointerPresentation';
import type { AgentInfo } from '../decoration/reducer';

type AIContentDecorationAttrs = {
	class: string;
	'data-testid': string;
	style?: string;
};

export const getAIContentDecorationAttrs = ({
	agentInfo,
	useAgentHighlightColor,
}: {
	agentInfo?: AgentInfo;
	useAgentHighlightColor: boolean;
}): AIContentDecorationAttrs => {
	if (!useAgentHighlightColor) {
		return {
			class: 'ai-in-editor-ai-content',
			'data-testid': 'ai-in-editor-ai-content',
		};
	}

	// Resolve the highlight from the same source as the badge and cursor line, so both share one
	// hue: a first party takes its avatar colour, a third party and the fallback go neutral grey,
	// and Rovo takes its own accent. Keeps the highlight from leaking the avatar colour onto the
	// neutral third-party / fallback pills. Fill only — the Figma highlight has no underline, so
	// this suppresses the shared `.ai-in-editor-ai-content` rule's dashed border-bottom, which
	// still applies to non-agent streaming and the collab agent-edit-chrome path.
	const { highlightBackgroundColor } = resolveTelepointerPresentation(agentInfo);

	return {
		class: 'ai-in-editor-ai-content',
		'data-testid': 'ai-in-editor-ai-content',
		style: `background-color: ${highlightBackgroundColor}; border-bottom-width: 0;`,
	};
};
